import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IEasyshipCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class EasyshipCredentialsStore implements ICredentialsStore {
    private _changes: IEasyshipCredentialsModel = {} as IEasyshipCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get apiKey() { return this._changes.api_key; };

    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default EasyshipCredentialsStore;
